import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { CREATE_CATALOGITEM_NEW_RECORD, GET_CATALOGITEM_NEW_RECORD, UPDATE_CATALOGITEM_NEW_RECORD, GET_CATALOGITEM_TERMS} from '../actions';
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";

import {
    createCatalogItemNewRecordSuccess,
    createCatalogItemNewRecordError,
    getCatalogItemNewRecordSuccess,
    getCatalogItemNewRecordError,
    trashCatalogItemSuccess,
    trashCatalogItemError,
    getCatalogItemTermsSuccess,
    getCatalogItemTermsError
} from './actions';

const CREATE_NEW_RECORD_ERROR = "New record success.";

const createCatalogItemNewRecordAsync = async (newRecord, payload) => {

  try{
    if (newRecord.catalogItemId > 0)
    {
       const responseObject = await centralApiAxios.put("catalog_items?id="+ newRecord.catalogItemId, newRecord, getActivityHeadersUpdated(payload));

      return {
        catalogItemRecord: responseObject.data,
        catalogItemId: responseObject.data.catalogItemId,
        trashed : newRecord.trashed,
        isCatalogItemCreate: !(newRecord.catalogItemId > 0),
        message: ""
      };
    }
    else
    {
      newRecord.Trashed = false;
      newRecord.DataSource = "1";
      newRecord.PrivacyType = "1";
      newRecord.LCID = "1033";
      newRecord.Multilingual = true;
      newRecord.Version = "1";
      newRecord.CreatedDateTime = new Date();
      newRecord.LastUpdatedDateTime = new Date();

      const responseObject = await centralApiAxios.post("catalog_items", newRecord, getActivityHeadersUpdated(payload));

      
      return {
        catalogItemRecord: responseObject.data,
        catalogItemId: responseObject.data.catalogItemId,
        trashed : newRecord.trashed,
        isCatalogItemCreate: !(newRecord.catalogItemId > 0),
        message: ""
      };
    }
  }
  catch (err) {
    // alert(err);
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* createCatalogItemNewRecord({ payload }) {
     const { history } = payload;
    try {
      const resultReturned = yield call(createCatalogItemNewRecordAsync, payload.newRecord.catalogItemRecord, payload);
      if (!resultReturned.message) {
        yield put(createCatalogItemNewRecordSuccess(resultReturned));
        if (resultReturned.isNewsItemCreate)
        {
           // history.push("/app/vocabulary-overview/"+ resultReturned.vocabulary_id);
        }
        if (payload.newRecord.catalogItemRecord.trashed == true) {
          history.push("/app/RecordListing/Vocabularies");
          window.location.reload();
        }
        else{
          window.location.reload();
        }
      } else {
        yield put(createCatalogItemNewRecordError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(createCatalogItemNewRecordError(CREATE_NEW_RECORD_ERROR));
    }
}

const getCatalogItemNewRecordAsync = async (payload) => {

  if (payload.catalogItemId == 0)
  {
    return {
      catalogItemRecord: undefined,
      catalogItemId: 0,
      message: ""
    };
  }
  try{
      let responseObject = {};
      responseObject.data = {};
      responseObject.data.catalogItemId = payload.catalogItemId;
      responseObject.data.name = "Catalog Name";
      responseObject.data.code = "Catalog Code";
      responseObject.data.costPerUnit = "90";

    try{
      responseObject = await centralApiAxios.get(`catalog_items/${payload.catalogItemId}?lcid=1033`, getActivityHeadersUpdated(payload));
    }
    catch(e){
     
    }
      
    return {
    catalogItemRecord: responseObject.data,
    catalogItemId: responseObject.data.catalogItemId,
    message: ""
    };
  }
  catch (err) {


    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

const trashCatalogItemAsync = async (payload) => {
  

  try{
    // eslint-disable-next-line
    const responseObject = await centralApiAxios.delete(`/catalog_items?id=${payload.catalogItemId}&trash=true`, getActivityHeadersUpdated(payload));
    
    return {
      message: ""
    };
  }
  catch (err) {
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* getCatalogItemNewRecord({ payload }) {
    // const { history } = payload;
    try {
      const resultReturned = yield call(getCatalogItemNewRecordAsync, payload);
      if (!resultReturned.message) {
       
        yield put(getCatalogItemNewRecordSuccess(resultReturned));
      } else {
        yield put(getCatalogItemNewRecordError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(getCatalogItemNewRecordError(CREATE_NEW_RECORD_ERROR));
    }
}

function* trashCatalogItem({ payload }) {
    // const { history } = payload;
    try {
      const resultReturned = yield call(trashCatalogItemAsync, payload);
      if (!resultReturned.message) {
         window.location.reload();
        yield put(trashCatalogItemSuccess(resultReturned));
      } else {
        yield put(trashCatalogItemError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(trashCatalogItemError(CREATE_NEW_RECORD_ERROR));
    }
}

const catalogItemAsync = async (payload) => {

  try{
    const recordTermListReturned = await centralApiAxios.get("Terms?trashed=false&pageSize=-1&vocabulary_id="+payload.vocabularyId, getActivityHeadersUpdated(payload));

    return {
      terms: recordTermListReturned.data,
      total_item_count: recordTermListReturned.data.totalItemCount,
          message: null,
    };
  }
  catch (err) {
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* getCatalogItemTerms({ payload }) {
    // const { history } = payload;
    try {
      const resultReturned = yield call(catalogItemAsync, payload);
      if (!resultReturned.message) {
        yield put(getCatalogItemTermsSuccess(resultReturned));
      } else {
        yield put(getCatalogItemTermsError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(getCatalogItemTermsError(CREATE_NEW_RECORD_ERROR));
    }
}

// eslint-disable-next-line
export function* watchCreateRecords(newRecord) {
  yield takeEvery(CREATE_CATALOGITEM_NEW_RECORD, createCatalogItemNewRecord);
}
// eslint-disable-next-line
export function* watchGetCatalogItemNewRecord(newRecord) {
  yield takeEvery(GET_CATALOGITEM_NEW_RECORD, getCatalogItemNewRecord);
}
 // eslint-disable-next-line 
export function* watchTrashCatalogItem(newRecord) {
  yield takeEvery(UPDATE_CATALOGITEM_NEW_RECORD, trashCatalogItem);
}
 // eslint-disable-next-line 
export function* watchGetCatalogItemTerms(newRecord) {
  yield takeEvery(GET_CATALOGITEM_TERMS, getCatalogItemTerms);
}

export default function* rootSaga() {
    yield all([
        fork(watchGetCatalogItemNewRecord),
        fork(watchCreateRecords),
        fork(watchTrashCatalogItem),
        fork(watchGetCatalogItemTerms)
    ]);
}
